export default __webpack_public_path__ + "static/media/2nd.3df78ed2.png";